import {environment} from "generated/env"

export function usePgexEnabled(): boolean {
    return !!environment.pgexEnabled
}
